import _extends from "@babel/runtime/helpers/extends";
import { GALLERY_CONSTS } from 'pro-gallery-lib';
import { behaviourParams_item_clickAction } from './behaviourParams_item_clickAction';
export const WIX_GALLERY_CONSTS = _extends({}, GALLERY_CONSTS, {
  behaviourParams_item_clickAction
});
//# sourceMappingURL=index.js.map